/**
 * EliteCart A/B test — async runtime layer.
 *
 * Cart-icon clicks are routed by the capture-phase listener in
 * snippets/elite-cart-variant-bootstrap.liquid, which also sets
 * theme.settings.eliteCartEnable synchronously. This file:
 *   - control:   no-ops window.EliteCart.* once it loads so the
 *                `ajaxProduct:added` add-to-cart auto-open is dead.
 *   - both:      reconciles the bootstrap against Amplitude's allocation
 *                (initialVariants, no mid-session flip) and fires the exposure
 *                for the server-assigned variant on the first cart interaction
 *                (window.villoidFireEliteCartExposure, called from theme.js
 *                Drawers.open for the cart), not on page load.
 *
 * See docs/superpowers/specs/elite-cart-test.md
 */
(function () {
  var FLAG_KEY = 'elite-cart-test';
  var DEPLOYMENT_KEY = 'client-RF1xJCVcbviTy08GICUpipvtEzeriy1w';
  var CACHE_KEY = 'elite_cart_variant_v2';

  var client = null;
  var fetched = false;
  var exposurePending = false;
  var exposed = false;

  function readBootstrappedVariant() {
    var v = document.documentElement.getAttribute('data-elite-cart-variant');
    return (v === 'treatment' || v === 'control') ? v : null;
  }

  function writeCache(variant) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ variant: variant, ts: Date.now() })); } catch (e) { }
  }

  function waitFor(predicate, callback, maxAttempts, interval) {
    maxAttempts = maxAttempts || 50;
    interval = interval || 100;
    var attempts = 0;
    (function check() {
      if (predicate()) return callback();
      if (++attempts > maxAttempts) return;
      setTimeout(check, interval);
    })();
  }

  function applyVariant(variant) {
    if (variant !== 'control') return;
    var attempts = 0;
    var maxAttempts = 25; // 25 * 200ms = 5s
    var interval = setInterval(function () {
      attempts++;
      if (window.EliteCart) {
        Object.keys(window.EliteCart).forEach(function (k) {
          if (typeof window.EliteCart[k] === 'function') {
            window.EliteCart[k] = function () { };
          }
        });
      }
      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  }

  function trackMismatch(bootstrap, server) {
    try {
      if (window.amplitude && typeof window.amplitude.track === 'function') {
        window.amplitude.track('elite_cart_bootstrap_mismatch', { bootstrap: bootstrap, server: server });
      }
    } catch (e) { }
  }

  // Every cart open goes through theme.Drawers.open for the cart (icon tap -> cart:open, add-to-cart
  // auto-open, Nosto quick-add), in both arms, so exposure is symmetric. It needs the server allocation:
  // if the cart is opened before fetch() has resolved, remember it and fire when it does.
  function fireExposure() {
    if (exposed) return;
    if (client && fetched) {
      exposed = true;
      try { client.exposure(FLAG_KEY); } catch (e) { }
    } else {
      exposurePending = true;
    }
  }
  window.villoidFireEliteCartExposure = fireExposure;

  function reconcile(bootstrap) {
    waitFor(function () { return !!window.Experiment; }, function () {
      try {
        var initialVariants = {};
        initialVariants[FLAG_KEY] = { value: bootstrap };
        client = window.Experiment.initializeWithAmplitudeAnalytics(DEPLOYMENT_KEY, {
          serverZone: 'EU',
          automaticExposureTracking: false,
          initialVariants: initialVariants
        });
      } catch (e) {
        console.warn('[elite-cart-ab] Experiment init failed:', e);
        return;
      }

      client.fetch().then(function () {
        var result = client.variant(FLAG_KEY);
        var server = result && result.value;
        if (!server) return;
        // Exposure tracks the SERVER-assigned variant, not whether the bootstrap
        // matched — gating on the match under-counts treatment (new users
        // bootstrap to 'control'). Mismatch handling (cache for next load +
        // monitoring) is a separate concern.
        if (server !== bootstrap) {
          writeCache(server);
          trackMismatch(bootstrap, server);
        }
        fetched = true;
        if (exposurePending) {
          exposurePending = false;
          fireExposure();
        }
      }).catch(function (err) {
        console.warn('[elite-cart-ab] experiment.fetch() failed:', err);
      });
    });
  }

  function init() {
    var bootstrap = readBootstrappedVariant();
    if (!bootstrap) return;
    applyVariant(bootstrap);
    reconcile(bootstrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
